export class Alert {
    id?: number;
    title_it?: string;
    title_en?: string;
    title_fr?: string;
    description_it?: string;
    description_en?: string;
    description_fr?: string;
    datastart?: any;
    dataend?: any;
    priorita?: number;

    constructor(){
        this.title_it = "";
        this.title_en = "";
        this.title_fr = "";
        this.description_it = "";
        this.description_en = "";
        this.description_fr = "";
        this.priorita = 1297;
    }
}